/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleCheckFill = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <rect width="16" height="16" rx="8" fill="#5CBEA9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29581 12.001C7.13122 12.001 6.97162 11.9303 6.85441 11.8063L4.18236 8.94867C3.93921 8.68865 3.93921 8.26594 4.18236 8.00591C4.4255 7.74589 4.82076 7.74589 5.0639 8.00591L7.21725 10.3061L11.2409 4.27888C11.4417 3.98018 11.8295 3.91217 12.1112 4.12419C12.3918 4.33888 12.4566 4.75359 12.2571 5.05495L7.80329 11.7223C7.69606 11.881 7.52897 11.9823 7.34693 11.9983C7.32947 11.9996 7.31326 12.001 7.29581 12.001Z"
        fill="white"
      />
    </BaseSvgIcon>
  )
}

export default CircleCheckFill
